// v2/molecules/NavbarTooltip.jsx
'use client'

import React from "react";
import { Tooltip } from "../atoms/Tooltip";

/**
 * NavbarTooltip
 * Wrap a nav icon/item and show a tooltip ONLY when the navbar/sidebar is collapsed.
 *
 * Props:
 * - label: string (tooltip text)
 * - collapsed: boolean (when true -> tooltip enabled)
 * - side: "top" | "right" | "bottom" | "left" (default: "right")
 * - children: the trigger element (usually <NavbarItem>...</NavbarItem>)
 * - className/contentClassName: forwarded to Tooltip
 */
export function NavbarTooltip({
  label,
  collapsed = false,
  side = "right",
  children,
  className = "",
  contentClassName = "",
}) {
  return (
    <Tooltip
      content={label}
      side={side}
      disabled={!collapsed}
      className={className}
      contentClassName={contentClassName}
    >
      {children}
    </Tooltip>
  );
}